import { useState } from "react"
import LabeledTextField from "../../components/UI/LabeledTextField"
import { Edit, Save } from "@carbon/icons-react"
import { X } from "react-feather"
import { useEffect } from "react"

const EditWaypoint = ({ provided, point, setWaypoints, index }) => {
    const [latVal, setLatVal] = useState(point)
    const [editLatLng, setEditLatLng] = useState(false)
    useEffect(() => {
        if (!editLatLng) {
            setWaypoints((prev) => (prev.map((val, i) => {
                if (i == index) {
                    return latVal
                } else {
                    return val
                }
            })))
        }
    }, [editLatLng])
    return (
        <>
            <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className="point mr-2 mt-2 relative grid grid-cols-4 gap-4 py-2 px-4 border rounded-xl w-fit"
            >
                <div className={`lat relative ${!editLatLng && "pointer-events-none"}`}>
                    {!editLatLng && (<><span className="text-sm text-slate-400">Latitude</span><br /></>)}
                    <LabeledTextField
                        placeholder={"Lattitude"}
                        label="Lattitude"
                        type="text"
                        content={editLatLng}
                        inputProps={{ value: latVal.lat, contentEditable: editLatLng, onChange: (e) => setLatVal((prev) => ({ ...prev, lat: e.target.value })) }}
                    />
                    {/* <input type="text" contentEditable={editLatLng} value={point.lat} className={`outline-none ${editLatLng && "border border-tblu rounded-lg"} p-2`} /> */}
                </div>
                <div className={`lat relative ${!editLatLng && "pointer-events-none"}`}>
                    {!editLatLng && (<><span className="text-sm text-slate-400">Longitude</span><br /></>)}
                    <LabeledTextField
                        placeholder={"Longitude"}
                        label="Longitude"
                        type="text"
                        content={editLatLng}
                        inputProps={{ value: latVal.lng, contentEditable: editLatLng, onChange: (e) => setLatVal((prev) => ({ ...prev, lng: e.target.value })) }}
                    />
                </div>
                <div className={`lat relative ${!editLatLng && "pointer-events-none"}`}>
                    {!editLatLng && (<><span className="text-sm text-slate-400">Altitude</span><br /></>)}
                    <LabeledTextField
                        placeholder={"Altitude"}
                        label="Altitude"
                        type="text"
                        content={editLatLng}
                        inputProps={{ value: latVal.alt, contentEditable: editLatLng, onChange: (e) => setLatVal((prev) => ({ ...prev, alt: e.target.value })) }}
                    />
                </div>
                <div className="flex items-center space-x-3">
                    <button
                        onClick={() =>
                            setWaypoints((prev) => prev.filter((_, i) => i !== index))
                        }
                        className="delete bg-red-400 text-white rounded-full p-1 top-0 left-[100%]"
                    >
                        <X />
                    </button>
                    {editLatLng ?
                        <Save size={24} className="cursor-pointer" onClick={() => { setEditLatLng(false) }} /> :
                        <Edit size={24} className="cursor-pointer" onClick={() => { setEditLatLng(true) }} />
                    }

                </div>
            </div>
        </>
    )
}

export default EditWaypoint;